import React, { useState } from 'react';
import { Addpatientdocument, uploadImage } from '../../api/helper';
import { Upload, FileText, X } from 'lucide-react';
import { ShowToast } from '../../helpers/ToastService';

const DocumentUploadForm = ({ data, onComplete }) => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [dragActive, setDragActive] = useState(false);

const handleSubmit = async (e) => {
  e.preventDefault();
  if (previews.length === 0) {
    ShowToast("Please upload at least one document");
    return;
  }

    if (!data?.response?.patientId || !data?.response?.agencyId) {
      console.error("Missing patientId or agencyId");
      return;
    }

    try {
      for (let file of previews) {
        const today = new Date().toISOString();

        const formattedDocumentName = file.name
          .replace(/\.[^/.]+$/, "")
          .replace(/[_-]/g, " ")
          .replace(/\s+/g, " ")
          .replace(/\b\w/g, char => char.toUpperCase());

        const payload = {
          documentType: "uploadedDoc",
          sentToPatient: "Yes",
          notes: "Auto-uploaded document",
          label: "Legal Document",
          status: "New",
          date: today,
          documentName: formattedDocumentName,
          attachFile: file.url,
          patientId: data?.response?.patientId,
          agencyId: data?.response?.agencyId
        };
        // console.log(payload,"pppppp====")
        const respo = await Addpatientdocument(payload);
        console.log("Upload Response:", respo);
        ShowToast(respo?.data?.message);
        setPreviews([])
      }


      onComplete?.(true);
    } catch (error) {
      console.error("Document upload error:", error);
      ShowToast("Failed to upload one or more documents");
    }
  };

  const handleFileProcess = async (files) => {
    const previewList = [];

    for (let file of files) {
      const formData = new FormData();
      formData.append("images", file);

      try {
        const response = await uploadImage(formData);
        const uploadedFileUrl = response.data.data[0].URL;
        // response.data.data[0].URL
        const reader = new FileReader();
        reader.onloadend = () => {
          previewList.push({
            name: file.name,
            size: file.size,
            url: uploadedFileUrl,
            preview: reader.result,
            type: file.type,
          });

          if (previewList.length === files.length) {
            // setUploadedFiles((prev) => [...prev, ...files]);
            setPreviews((prev) => [...prev, ...previewList]);
          }
        };

        reader.readAsDataURL(file);
      } catch (error) {
        console.error('Upload failed:', error);
      }
    }
  };

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files || []);
    handleFileProcess(files);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    const files = Array.from(e.dataTransfer.files || []);
    handleFileProcess(files);
  };


  const removeFile = (index) => {
    // setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
    setPreviews((prev) => prev.filter((_, i) => i !== index));
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
  };

  return (
    <div className="docupl-card">
      <div className="docupl-card-content">
        <form onSubmit={handleSubmit}>
          <div className="docupl-field-group">
            <label htmlFor="docUpload" className="docupl-label">Upload Documents *</label>
            <div
              className={`docupl-upload-box ${dragActive ? 'drag-active' : ''}`}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
            >
              <div className="docupl-upload-text">
                <div className="docupl-upload-icon">📤</div>
                <div>
                  <label htmlFor="docUpload" className="docupl-file-label">
                    <span className="docupl-link">Choose files</span>
                    <span className="docupl-subtext"> or drag and drop</span>
                  </label>
                  <input
                    id="docUpload"
                    type="file"
                    // multiple
                    onChange={handleFileUpload}
                    className="docupl-hidden-input"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  // required
                  />

                </div>
                <p className="docupl-description">
                  PDF, DOC, DOCX, JPG, PNG up to 10MB each
                </p>
              </div>
            </div>
          </div>

          {previews.length > 0 && (
            <div className="docupl-preview-section">
              <label className="docupl-label">Uploaded Files</label>
              <div className="docupl-preview-list">
                {previews.map((file, index) => (
                  <div key={index} className="docupl-preview-item">
                    <div className="docupl-preview-details">
                      <span className="docupl-file-icon">📄</span>
                      <div>
                        <p className="docupl-file-name">{file.name}</p>
                        <p className="docupl-file-size">{formatFileSize(file.size)}</p>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="docupl-remove-btn"
                      onClick={() => removeFile(index)}
                    >
                      ❌
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="docupl-suggestions">
            <p style={{ textAlign: 'left' }} className='docupl-info-text'>
              <strong >Suggested documents to upload:</strong><br />
              • Previous medical records
              • Insurance cards (front and back)
              • List of current medications
              • Previous test results or lab reports
              • Referral letters from other providers
            </p>
          </div>

          <button type="submit" className="docupl-submit-btn">
            Save Documents
          </button>
        </form>
      </div>
    </div>
  );
};

export default DocumentUploadForm;
